import React from 'react';
import './CatalogItem.css';
import {connect} from 'react-redux';
import { Card, Descriptions, message, Button, Tabs, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons'
import { DcatCatalogs } from '../../redux';
import { LoadingComponent } from '../../utils/ui';
import { getValueOrDefault, subsetByURI } from '../../virtuoso/helper';
import DeleteCatalog from './DeleteCatalog';

const RDFS_LABEL = 'http://www.w3.org/2000/01/rdf-schema#label';
const DCAT_DATASET = 'http://www.w3.org/ns/dcat#dataset';
const DCAT_THEME = 'http://www.w3.org/ns/dcat#themeTaxonomy';
const DCTERMS_PUBLISHER = 'http://purl.org/dc/terms/publisher';
const DCTERMS_DESCRIPTION = 'http://purl.org/dc/terms/description';
const DCAT_ACCESS_URL = 'http://www.w3.org/ns/dcat#accessURL';

class CatalogItem extends React.Component {

  state = {
    loaded: false,
    loading: false,
    values: [],
    statisitc: [],      //Статистика по элементам в графе catalogCount, conceptSchemeCount и resourceCount
    deleteDialogOpen: false,
  }

  componentDidMount() {
    this.loadCatalogDetails();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.catalog !== this.props.catalog || prevProps.graph !== this.props.graph) {
      this.loadCatalogDetails();
    }
  }

  loadCatalogDetails() {
    const {catalog, graph, dispatch, rdfTypes} = this.props;
    if (!catalog || !graph) return;

    this.setState({loaded: false, loading: true, values: []});
    return Promise.all([
      dispatch(DcatCatalogs.loadCatalogDetails(catalog, graph)),
      dispatch(DcatCatalogs.loadCatalogCountDetails(graph, rdfTypes))
    ]).then(response => {
        const values = response[0]?.results?.bindings || [];
        const statisitc = response[1]?.results?.bindings || [];
        this.setState({loaded: true, loading: false, values, statisitc});
      })
      .catch(e => {
        message.error(`Ошибка получения описания каталога. ${e}`);
        this.setState({loaded: true, loading: false, values: []});
      });
  }

  renderField(predicat) {
    const {lang, factory} = this.props;
    const {values} = this.state;

    if (!factory || !factory.ui) return null;
    const Component = factory.ui.getUIComponent(predicat);
    return <Component uri={predicat} values={values} lang={lang} factory={factory}/>
  }

  renderTitle(){
    const { loaded, loading, values } = this.state;
    const {catalog, graph, lang} = this.props;
    const title = getValueOrDefault(RDFS_LABEL, lang, values, catalog);
    return (
      <>{loaded? title: catalog} <small>{"("+catalog+")"}</small></>
    )
  }

  openDeleteDialog = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({deleteDialogOpen: true});
  }

  closeDeleteDialog = () => {
    this.setState({deleteDialogOpen: false});
  }

  deleteCompleted = () => {
    this.setState({deleteDialogOpen: false}, () => {
      this.props.onDeleted?.();
    });
  }
  render() {
    const { loaded, loading, values, statisitc, deleteDialogOpen } = this.state;
    const {catalog, graph, lang} = this.props;    
    const statistic = statisitc[0] || {};
    const description = getValueOrDefault(DCTERMS_DESCRIPTION, lang, values, '');
    const hasDescription = String(description).trim().length > 0;
    const datasetCount = subsetByURI(values, DCAT_DATASET).length;
    const themeCount = subsetByURI(values, DCAT_THEME).length;
    //console.log(this);
    return (
      <Card className="catalog-item-card" title={this.renderTitle()} style={{width: '100%'}}
        extra={<>
          <Button type="link" onClick={()=>this.props.onClick()}>More</Button>
          &nbsp;&nbsp;
          <Tooltip placement="top" title={"Удалить каталог"}>
            <Button danger icon={<CloseOutlined />} onClick={this.openDeleteDialog}/>
          </Tooltip>
        </>}>
        {loading || !loaded ? <LoadingComponent /> :
        <Tabs
          items={[
            {
              key: 'catalog',
              forceRender: true,
              label: 'Каталог',
              children: (
                <Descriptions className="catalog-item-descriptions" column={1} size="small" bordered={false}>
                  <Descriptions.Item label="URI графа">{graph}</Descriptions.Item>
                  {hasDescription && (
                    <Descriptions.Item label="Описание">{this.renderField(DCTERMS_DESCRIPTION)}</Descriptions.Item>
                  )}
                  <Descriptions.Item label="Издатель">{this.renderField(DCTERMS_PUBLISHER)}</Descriptions.Item>
                  <Descriptions.Item label="URL доступа">{this.renderField(DCAT_ACCESS_URL)}</Descriptions.Item>
                </Descriptions>
              ),
            },
            // {
            //   key: 'graph',
            //   forceRender: true,
            //   label: 'Граф',
            //   children: (
            //     <Descriptions column={1} size="small" bordered={false}>
            //       <Descriptions.Item label="URI графа">{graph}</Descriptions.Item>
            //     </Descriptions>
            //   ),
            // },
            {
              key: 'elements',
              forceRender: true,
              label: 'Элементы',
              children: (
                <Descriptions column={1} size="small" bordered={false}>
                  <Descriptions.Item label="Каталогов в графе">{statistic.catalogCount?.value}</Descriptions.Item>
                  <Descriptions.Item label="Активов">{datasetCount} из {statistic.resourceCount?.value}</Descriptions.Item>
                  <Descriptions.Item label="Используемые справочники">{themeCount} из {statistic.conceptSchemeCount?.value}</Descriptions.Item>
                  <Descriptions.Item label="Объекты в реестре">{statistic.vocabsCount?.value}</Descriptions.Item>
                </Descriptions>
              ),
            },
          ]}
        />
        }
        {deleteDialogOpen && (
          <DeleteCatalog
            open={true}
            catalogURI={catalog}
            graphURI={graph}
            onClose={this.closeDeleteDialog}
            onDeleted={this.deleteCompleted}
          />
        )}
      </Card>
    )
  }
}

function mapStateToProps(state, props) {
  const {vset, vocabs} = state;
  const {lang} = props;
  return {
    lang: (lang)?lang: vset.lang,
    isSignedIn: vset.isSignedIn,
    inGroup: vset.inGroup,
    rdfTypes: vocabs.rdfTypes,
  };
}
  
export default connect(mapStateToProps)(CatalogItem);